<!--<app-header></app-header>
<app-leftcolWebsite></app-leftcolWebsite>
<router-outlet></router-outlet>
<app-footer></app-footer>-->
<app-header (menuToggle)="toggleMenu()"></app-header>

<div class="main-wrapper">
  <app-leftcolWebsite [class.hide-menu]="isMenuHidden"></app-leftcolWebsite>

  <div class="content">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
  
</div>
